import { ChangeDetectionStrategy, Component, effect, untracked } from '@angular/core';

import { LayerDataAttributesListComponent } from '@connect-services/client/components/field-intervention-layer-detail/layer-data-attributes-list/layer-data-attributes-list.component';
import { NoDataToDisplayComponent } from '@connect-services/client/components/no-data-to-display/no-data-to-display.component';
import { AbstractLayerDetailComponent } from '@connect-services/client/components/project-settings/abstract-layer-detail.component';
import { ProjectSettingsLayerDetailTemplateComponent } from '@connect-services/client/components/project-settings/project-settings-layer-detail-template/project-settings-layer-detail-template.component';
import { Layer } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { LoadingComponent } from '@shared/client/components/loading/loading.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        LayerDataAttributesListComponent,
        LoadingComponent,
        NoDataToDisplayComponent,
        ProjectSettingsLayerDetailTemplateComponent,
        RessourcesModule,
    ],
    selector: 'app-deposit-layer-detail',
    templateUrl: './deposit-layer-detail.component.html',
})
export class DepositLayerDetailComponent extends AbstractLayerDetailComponent {
    protected readonly Layer = Layer;

    public constructor() {
        super();

        effect(() => {
            if (
                !this.layerBloc.value() ||
                (this.layerBloc.value()?.type !== Layer.TypeEnum.TABLE &&
                    this.layerBloc.value()?.type !== Layer.TypeEnum.REFERENCE_DATA)
            ) {
                return;
            }
            untracked(() => this.setDataAttributes());
        });
    }
}
